import { get, patch, post, remove } from 'vio-libs';
export function getEdgeOffering(organization, edgeOfferingId, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`edge-offerings?organization=${organization}&edge_offering=${edgeOfferingId}`);
    }
    return get(`v1/${organization}/kex/offerings/${edgeOfferingId}?expand=contacts`, undefined, true);
}
export function getEdgeOfferings(organization, kexProfileId, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`edge-offerings?organization=${organization}&kex_profile=${kexProfileId}`);
    }
    return get(`v1/${organization}/kex/offerings?profile=${kexProfileId}&expand=contacts`, undefined, true);
}
export function postNewEdgeOffering(organization, edgeOffering, consumerAPI = false) {
    if (!consumerAPI) {
        return post(`edge-offerings?organization=${organization}`, {
            data: Object.assign({}, edgeOffering)
        });
    }
    return post(`v1/${organization}/kex/offerings?expand=contacts`, {
        data: Object.assign({}, edgeOffering)
    }, true);
}
export function patchExistingEdgeOffering(organization, edgeOfferingId, update, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`edge-offerings?organization=${organization}`, {
            data: {
                edge_offering_id: edgeOfferingId,
                update
            }
        });
    }
    return patch(`v1/${organization}/kex/offerings/${edgeOfferingId}?expand=contacts`, {
        data: Object.assign({}, update)
    }, true);
}
export function removeEdgeOffering(organization, edgeOfferingId, consumerAPI = false) {
    if (!consumerAPI) {
        return remove(`edge-offerings?organization=${organization}`, {
            data: {
                edge_offering_id: edgeOfferingId
            }
        });
    }
    return remove(`v1/${organization}/kex/offerings/${edgeOfferingId}`, undefined, true);
}
